import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';
import Home from './HomePage';
import PrivateAdminRoute from './PrivateAdminRoute';
import CareerCoachEnrollment from './careerCoachEnrollment/CareerCoachEnrollment';
import CareerCoachForm from './careerCoachEnrollment/CareerCoachForm';
import ProfessionalEnrollment from './professionalEnrollment/ProfessionalEnrollment';
import ProfessionalForm from './professionalEnrollment/ProfessionalForm';
import MentorsList from './mentorsList/MentorsList';
import Profile from './profileComponent/Profile';
import Login from './loginComponents/Login';
import ForgotPassword from './loginComponents/ForgotPassword';
import MentorDetails from './mentorDetails/MentorDetails';
import Register from './registerComponent/Register';
import Enroll from './joinComponent/Enroll';
import MeetMentors from './meetMentors/MeetMentors';
import ExpertsList from './expertList/ExpertList';
import ExpertDetails from './expertDetails/ExpertDetails';
import ExpertsTerms from './policiesComponent/ExpertsTerms';
import PrivacyPolicy from './policiesComponent/PrivacyPolicy';
import CareerCoachTerms from './policiesComponent/CareerCoachTerms';
import CoachJoinTerms from './policiesComponent/CareerJoinTerms';
import ExpertJoinTerms from './policiesComponent/ExpertJoinTerms';
import HomePageTerms from './policiesComponent/HomePageTerms';
import RefundCancellationTerms from './policiesComponent/RefundCancellationTerms';
import ExpertSuggestion from './homeComponents/ExpertSuggestions';
import MentorSuggestion from './homeComponents/MentorSuggestions';
import UpcomingMeetings from './profileComponent/UpcomingMeetings';
import UserMentorSuggestions from './homeComponents/UserMentorSuggestions';
import UserExpertSuggestions from './homeComponents/UserExpertSuggestions';


function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route
        path="/*"
        element={
          <PrivateAdminRoute>
            <AdminPanel />
          </PrivateAdminRoute>
        }/* TODO: some routes here need to not directly accessible by the url*/
      />
      <Route path="/career-coach-enrollment" element={<CareerCoachEnrollment />} />
      <Route path="/career-coach-enrollment-form" element={<CareerCoachForm />} />
      <Route path="/professional-enrollment" element={<ProfessionalEnrollment />} />
      <Route path="/professional-enrollment-form" element={<ProfessionalForm />} />
      <Route path="/career-coaches" element={<MentorsList />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/login" element={<Login />} />
      <Route path="/career-coach-profile/:mentorId" element={<MentorDetails />} />
      <Route path="/register" element={<Register />} />
      <Route path="/enroll" element={<Enroll />} />
      <Route path="/meet-experts" element={<MeetMentors />} />
      <Route path="/professionals" element={<ExpertsList />} />
      <Route path="/professional-profile/:expertId" element={<ExpertDetails />} />
      <Route path="/career-coach-terms-and-conditions" element={<CareerCoachTerms />} />
      <Route path="/professional-terms-and-conditions" element={<ExpertsTerms />} />
      <Route path="/coach-enroll-terms-and-conditions" element={<CoachJoinTerms />} />
      <Route path="/professional-enroll-terms-and-conditions" element={<ExpertJoinTerms />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/refund-cancellation-policy" element={<RefundCancellationTerms />} />
      <Route path="/terms-and-conditions" element={<HomePageTerms />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/expert-tips" element={<ExpertSuggestion />} />
      <Route path="/mentor-tips" element={<MentorSuggestion />} />
      <Route path="/upcoming-meetings" element={<UpcomingMeetings />} />
      <Route path="/user-mentor-tips" element={<UserMentorSuggestions />} />
      <Route path="/user-expert-tips" element={<UserExpertSuggestions />} />
    </Routes>
  );
}

export default App;
